import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const DeleteThreadDialog = ({ open, onClose, onConfirm, threadTitle }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-thread-dialog-title"
      aria-describedby="delete-thread-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: 2,
          minWidth: { xs: '90%', sm: 400 },
        }
      }}
    >
      <DialogTitle 
        id="delete-thread-dialog-title"
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 1,
          pb: 1 
        }}
      >
        <WarningAmberIcon color="warning" />
        Delete Thread
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-thread-dialog-description">
          Are you sure you want to delete <strong>"{threadTitle}"</strong>?
          <br />
          <br />
          This will permanently delete the thread and all its messages. This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button 
          onClick={onClose} 
          variant="outlined"
          color="inherit"
        >
          Cancel
        </Button>
        <Button 
          onClick={onConfirm} 
          variant="contained" 
          color="error"
          autoFocus
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteThreadDialog;